/* stylelint-disable discord/var-validator */
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
If you need to add or edit existing variables, check out
discord_common/js/packages/tokens/definitions, then run
`clyde mana tokens generate` */

import {_private as themeDefinitions} from '../../themes/generated/generated-definitions';

const {Themes} = themeDefinitions;
type Themes = typeof Themes;

import type {SemanticColors} from './generated-definitions';

export type ExperimentName =
  | 'visual-refresh'
  | 'visual-refresh-chat-input'
  | 'refresh-fast-follow-avatars'
  | 'refresh-fast-follow-guild-bg';

type SemanticColorName = keyof SemanticColors;

type ColorDefinition = Partial<SemanticColors[string]>;

type SemanticColorExperimentMap = {
  [K in SemanticColorName]?: {
    [E in ExperimentName]?: Partial<ColorDefinition>;
  };
};

const SemanticColorExperiments: SemanticColorExperimentMap = {
  ACTIVITY_CARD_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  AUTOCOMPLETE_BG: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  BACKGROUND_FLOATING: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  BACKGROUND_MENTIONED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
    },
  },
  BACKGROUND_MENTIONED_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_YELLOW_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_YELLOW_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_YELLOW_4', opacity: 0.0392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_YELLOW_4', opacity: 0.0392156862745098},
    },
  },
  BACKGROUND_MESSAGE_HIGHLIGHT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLURPLE_16', opacity: 0.1607843137254902},
      [Themes.LIGHT]: {raw: 'OPACITY_BLURPLE_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLURPLE_16', opacity: 0.1607843137254902},
      [Themes.DARKER]: {raw: 'OPACITY_BLURPLE_16', opacity: 0.1607843137254902},
    },
  },
  BACKGROUND_MESSAGE_HIGHLIGHT_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLURPLE_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_BLURPLE_20', opacity: 0.2},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLURPLE_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_BLURPLE_12', opacity: 0.12156862745098039},
    },
  },
  BACKGROUND_MESSAGE_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
  BACKGROUND_MODIFIER_ACCENT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_28', opacity: 0.2784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BACKGROUND_MODIFIER_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.DARKER]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
    },
  },
  BACKGROUND_MODIFIER_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
  BACKGROUND_MODIFIER_SELECTED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  BACKGROUND_PRIMARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_66', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_2', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_95', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_82', opacity: 1},
    },
  },
  BACKGROUND_SECONDARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_69', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_2', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_97', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_86', opacity: 1},
    },
  },
  BACKGROUND_TERTIARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_73', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_4', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_100', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_92', opacity: 1},
    },
  },
  BG_BASE_PRIMARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_66', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_2', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_95', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_82', opacity: 1},
    },
  },
  BG_BASE_SECONDARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_69', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_2', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_97', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_86', opacity: 1},
    },
  },
  BG_BASE_TERTIARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_73', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_4', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_100', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_92', opacity: 1},
    },
  },
  BG_BRAND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLURPLE_50', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLURPLE_50', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLURPLE_50', opacity: 1},
      [Themes.DARKER]: {raw: 'BLURPLE_50', opacity: 1},
    },
  },
  BG_MOD_FAINT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
    },
  },
  BG_MOD_STRONG: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  BG_MOD_SUBTLE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
  BORDER_FAINT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.DARKER]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
    },
  },
  BORDER_STRONG: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_48', opacity: 0.47843137254901963},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
    },
  },
  BORDER_SUBTLE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_28', opacity: 0.2784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BUTTON_DANGER_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_NEW_50', opacity: 1},
    },
  },
  BUTTON_DANGER_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_NEW_61', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_NEW_61', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_NEW_61', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_NEW_61', opacity: 1},
    },
  },
  BUTTON_DANGER_BACKGROUND_DISABLED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_NEW_50', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_NEW_50', opacity: 1},
    },
  },
  BUTTON_DANGER_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_NEW_57', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_NEW_57', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_NEW_57', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_NEW_57', opacity: 1},
    },
  },
  BUTTON_DANGER_BORDER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
    },
  },
  BUTTON_FILLED_BRAND_BORDER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
    },
  },
  BUTTON_FILLED_BRAND_INVERTED_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_17', opacity: 1},
    },
  },
  BUTTON_FILLED_BRAND_INVERTED_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_9', opacity: 1},
    },
  },
  BUTTON_FILLED_BRAND_INVERTED_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLACK', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLACK', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLACK', opacity: 1},
      [Themes.DARKER]: {raw: 'BLACK', opacity: 1},
    },
  },
  BUTTON_FILLED_WHITE_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_17', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_17', opacity: 1},
    },
  },
  BUTTON_FILLED_WHITE_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_9', opacity: 1},
    },
  },
  BUTTON_FILLED_WHITE_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLACK', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLACK', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLACK', opacity: 1},
      [Themes.DARKER]: {raw: 'BLACK', opacity: 1},
    },
  },
  BUTTON_OUTLINE_DANGER_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BUTTON_OUTLINE_DANGER_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.LIGHT]: {raw: 'PRIMARY_400', opacity: 0.08},
      [Themes.MIDNIGHT]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.DARKER]: {raw: 'PRIMARY_500', opacity: 0.3},
    },
  },
  BUTTON_OUTLINE_DANGER_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_28', opacity: 0.2784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  BUTTON_OUTLINE_DANGER_BORDER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
    },
  },
  BUTTON_OUTLINE_DANGER_BORDER_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
    },
  },
  BUTTON_OUTLINE_DANGER_BORDER_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_4', opacity: 0.0392156862745098},
    },
  },
  BUTTON_OUTLINE_DANGER_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_345', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_500', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_345', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_345', opacity: 1},
    },
  },
  BUTTON_OUTLINE_DANGER_TEXT_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_345', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_500', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_345', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_345', opacity: 1},
    },
  },
  BUTTON_OUTLINE_DANGER_TEXT_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_345', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_500', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_345', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_345', opacity: 1},
    },
  },
  BUTTON_POSITIVE_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_50', opacity: 1},
    },
  },
  BUTTON_POSITIVE_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_57', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_57', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_57', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_57', opacity: 1},
    },
  },
  BUTTON_POSITIVE_BACKGROUND_DISABLED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_50', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_50', opacity: 1},
    },
  },
  BUTTON_POSITIVE_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_53', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_53', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_53', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_53', opacity: 1},
    },
  },
  BUTTON_POSITIVE_BORDER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_WHITE_8', opacity: 0.0784313725490196},
    },
  },
  BUTTON_SECONDARY_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BUTTON_SECONDARY_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.LIGHT]: {raw: 'PRIMARY_400', opacity: 0.08},
      [Themes.MIDNIGHT]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.DARKER]: {raw: 'PRIMARY_500', opacity: 0.3},
    },
  },
  BUTTON_SECONDARY_BACKGROUND_DISABLED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BUTTON_SECONDARY_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_28', opacity: 0.2784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  BUTTON_SECONDARY_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_6', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_95', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_6', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_6', opacity: 1},
    },
  },
  BUTTON_TRANSPARENT_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.LIGHT]: {raw: 'OPACITY_16', opacity: 0.1607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
    },
  },
  BUTTON_TRANSPARENT_BACKGROUND_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.LIGHT]: {raw: 'PRIMARY_400', opacity: 0.08},
      [Themes.MIDNIGHT]: {raw: 'PRIMARY_500', opacity: 0.3},
      [Themes.DARKER]: {raw: 'PRIMARY_500', opacity: 0.3},
    },
  },
  BUTTON_TRANSPARENT_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_28', opacity: 0.2784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  BUTTON_TRANSPARENT_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_6', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_95', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_6', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_6', opacity: 1},
    },
  },
  CARD_PRIMARY_BG: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  CARD_SECONDARY_BG: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
  CHANNEL_ICON: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_27', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_42', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_36', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_34', opacity: 1},
    },
  },
  CHANNELS_DEFAULT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_27', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_42', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_36', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_34', opacity: 1},
    },
  },
  HEADER_MUTED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_22', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_33', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_29', opacity: 1},
    },
  },
  HEADER_PRIMARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_71', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_8', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_2', opacity: 1},
    },
  },
  HEADER_SECONDARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_69', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_10', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_5', opacity: 1},
    },
  },
  ICON_MUTED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_22', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_33', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_29', opacity: 1},
    },
  },
  ICON_PRIMARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_2', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_59', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_15', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_10', opacity: 1},
    },
  },
  ICON_SECONDARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_16', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_44', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_27', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_23', opacity: 1},
    },
  },
  INFO_DANGER_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_RED_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_RED_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_RED_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_RED_8', opacity: 0.0784313725490196},
    },
  },
  INFO_DANGER_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'RED_NEW_21', opacity: 1},
      [Themes.LIGHT]: {raw: 'RED_NEW_54', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'RED_NEW_37', opacity: 1},
      [Themes.DARKER]: {raw: 'RED_NEW_32', opacity: 1},
    },
  },
  INFO_HELP_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLUE_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_BLUE_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLUE_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_BLUE_8', opacity: 0.0784313725490196},
    },
  },
  INFO_HELP_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLUE_NEW_24', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLUE_NEW_56', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLUE_NEW_40', opacity: 1},
      [Themes.DARKER]: {raw: 'BLUE_NEW_34', opacity: 1},
    },
  },
  INFO_POSITIVE_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_GREEN_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_GREEN_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_GREEN_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_GREEN_8', opacity: 0.0784313725490196},
    },
  },
  INFO_POSITIVE_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_24', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_55', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_40', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_34', opacity: 1},
    },
  },
  INFO_WARNING_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_YELLOW_8', opacity: 0.0784313725490196},
    },
  },
  INFO_WARNING_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'YELLOW_NEW_22', opacity: 1},
      [Themes.LIGHT]: {raw: 'YELLOW_NEW_54', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'YELLOW_NEW_38', opacity: 1},
      [Themes.DARKER]: {raw: 'YELLOW_NEW_32', opacity: 1},
    },
  },
  INPUT_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLACK_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_BLACK_8', opacity: 0.0784313725490196},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLACK_8', opacity: 0.0784313725490196},
      [Themes.DARKER]: {raw: 'OPACITY_BLACK_8', opacity: 0.0784313725490196},
    },
  },
  INPUT_BORDER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_20', opacity: 0.2},
      [Themes.LIGHT]: {raw: 'OPACITY_36', opacity: 0.3607843137254902},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_32', opacity: 0.3215686274509804},
      [Themes.DARKER]: {raw: 'OPACITY_20', opacity: 0.2},
    },
  },
  INPUT_FOCUSED_BORDER: {
    ['visual-refresh']: {[Themes.DARK]: {raw: 'WHITE', opacity: 0.04}, [Themes.LIGHT]: {raw: 'BLACK', opacity: 0.04}},
  },
  INPUT_PLACEHOLDER_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_32', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_44', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_36', opacity: 1},
    },
  },
  INTERACTIVE_ACTIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_71', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_8', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_2', opacity: 1},
    },
  },
  INTERACTIVE_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_71', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_8', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_2', opacity: 1},
    },
  },
  INTERACTIVE_NORMAL: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_16', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_44', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_27', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_23', opacity: 1},
    },
  },
  MENTION_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.LIGHT]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
    },
  },
  MENTION_FOREGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLURPLE_8', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLURPLE_71', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLURPLE_26', opacity: 1},
      [Themes.DARKER]: {raw: 'BLURPLE_18', opacity: 1},
    },
  },
  MESSAGE_REACTED_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.LIGHT]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
      [Themes.DARKER]: {raw: 'OPACITY_BLURPLE_24', opacity: 0.23921568627450981},
    },
  },
  MESSAGE_REACTED_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLURPLE_2', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLURPLE_75', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLURPLE_21', opacity: 1},
      [Themes.DARKER]: {raw: 'BLURPLE_14', opacity: 1},
    },
  },
  MODAL_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  MODAL_FOOTER_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_64', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_91', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_79', opacity: 1},
    },
  },
  PREMIUM_NITRO_PINK_TEXT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'PINK_33', opacity: 1},
      [Themes.LIGHT]: {raw: 'PINK_61', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'PINK_55', opacity: 1},
      [Themes.DARKER]: {raw: 'PINK_51', opacity: 1},
    },
  },
  SCROLLBAR_AUTO_SCROLLBAR_COLOR_THUMB: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_31', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_45', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_43', opacity: 1},
    },
  },
  SCROLLBAR_AUTO_SCROLLBAR_COLOR_TRACK: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_74', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_3', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_98', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_90', opacity: 1},
    },
  },
  SCROLLBAR_AUTO_THUMB: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_36', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_30', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_45', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_42', opacity: 1},
    },
  },
  SCROLLBAR_AUTO_TRACK: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'TRANSPARENT', opacity: 0},
      [Themes.LIGHT]: {raw: 'TRANSPARENT', opacity: 0},
      [Themes.MIDNIGHT]: {raw: 'TRANSPARENT', opacity: 0},
      [Themes.DARKER]: {raw: 'TRANSPARENT', opacity: 0},
    },
  },
  SCROLLBAR_THIN_THUMB: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_32', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_46', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_44', opacity: 1},
    },
  },
  SPINE_DEFAULT: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
      [Themes.LIGHT]: {raw: 'OPACITY_48', opacity: 0.47843137254901963},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
      [Themes.DARKER]: {raw: 'OPACITY_44', opacity: 0.4392156862745098},
    },
  },
  SPOILER_HIDDEN_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_36', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_30', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_45', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_42', opacity: 1},
    },
  },
  TEXT_BRAND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLURPLE_25', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLURPLE_49', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLURPLE_41', opacity: 1},
      [Themes.DARKER]: {raw: 'BLURPLE_35', opacity: 1},
    },
  },
  TEXT_LINK: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'BLUE_NEW_26', opacity: 1},
      [Themes.LIGHT]: {raw: 'BLUE_NEW_49', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'BLUE_NEW_42', opacity: 1},
      [Themes.DARKER]: {raw: 'BLUE_NEW_36', opacity: 1},
    },
  },
  TEXT_MUTED: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_22', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_38', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_33', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_29', opacity: 1},
    },
  },
  TEXT_NORMAL: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_9', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_69', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_10', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_5', opacity: 1},
    },
  },
  TEXT_POSITIVE: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'GREEN_NEW_24', opacity: 1},
      [Themes.LIGHT]: {raw: 'GREEN_NEW_55', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'GREEN_NEW_40', opacity: 1},
      [Themes.DARKER]: {raw: 'GREEN_NEW_34', opacity: 1},
    },
  },
  TEXT_PRIMARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_71', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_8', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_2', opacity: 1},
    },
  },
  TEXT_SECONDARY: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_16', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_44', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_27', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_23', opacity: 1},
    },
  },
  TEXT_WARNING: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'YELLOW_NEW_22', opacity: 1},
      [Themes.LIGHT]: {raw: 'YELLOW_NEW_54', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'YELLOW_NEW_38', opacity: 1},
      [Themes.DARKER]: {raw: 'YELLOW_NEW_32', opacity: 1},
    },
  },
  USER_PROFILE_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
  USER_PROFILE_OVERLAY_BACKGROUND: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'NEUTRAL_60', opacity: 1},
      [Themes.LIGHT]: {raw: 'NEUTRAL_1', opacity: 1},
      [Themes.MIDNIGHT]: {raw: 'NEUTRAL_83', opacity: 1},
      [Themes.DARKER]: {raw: 'NEUTRAL_73', opacity: 1},
    },
  },
  USER_PROFILE_OVERLAY_BACKGROUND_HOVER: {
    ['visual-refresh']: {
      [Themes.DARK]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
      [Themes.LIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.MIDNIGHT]: {raw: 'OPACITY_12', opacity: 0.12156862745098039},
      [Themes.DARKER]: {raw: 'OPACITY_8', opacity: 0.0784313725490196},
    },
  },
};

export const _private = {SemanticColorExperiments};
